import React from 'react';
import { Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../hooks/useAuth';

interface ScopeIndicatorProps {
  resource: string;
}

const ScopeIndicator: React.FC<ScopeIndicatorProps> = ({ resource }) => {
  const { getScope } = useAuth();
  const { t } = useTranslation('common');
  
  if (getScope(resource) !== 'assigned') {
    return null;
  }

  return (
    <Alert variant="info" className="py-2 px-3 mb-3 shadow-sm border-0 d-flex align-items-center">
      <svg 
        width="16" 
        height="16" 
        fill="currentColor" 
        viewBox="0 0 16 16" 
        className="me-2 text-info"
      >
        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
      </svg>
      <small className="fw-medium">{t('messages.scopeIndicator')}</small>
    </Alert>
  );
};

export default ScopeIndicator;
